import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/* ProtectedRoute — gates admin-only pages.
 * Shows a loader while bootstrapping. Redirects to /admin/login on unauthenticated
 * and remembers the requested URL via location state. */
export default function ProtectedRoute({ children }) {
  const { user, bootstrapped } = useAuth();
  const location = useLocation();

  if (!bootstrapped) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--st-bg)]">
        <Loader2 size={22} className="animate-spin text-[var(--st-maroon)]" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location.pathname + location.search }} replace />;
  }

  return children;
}
